import { render } from "./Service.vue?vue&type=template&id=1fb6bc15"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"

import "./Service.vue?vue&type=style&index=0&id=1fb6bc15&lang=scss"
script.render = render

export default script